import { AccountType } from '../../../constants/constants';

export enum EcommerceEvent {
    ClickStartFreeTrial = 'EcommerceEvent.ClickStartFreeTrial',
    ClickViewPricing = 'EcommerceEvent.ClickViewPricing',
    ClickContactSales = 'EcommerceEvent.ContactSales',
    UpgradeToPro = 'Licenses.UpgradeToPro',
}

export type EcommercePayload = {
    invocationMethod?: string;
    subscriptionType?: AccountType;
};

export interface EcommerceEventEventMap {
    [EcommerceEvent.ClickStartFreeTrial]: EcommercePayload;
    [EcommerceEvent.ClickViewPricing]: EcommercePayload;
    [EcommerceEvent.ClickContactSales]: EcommercePayload;
    [EcommerceEvent.UpgradeToPro]: EcommercePayload;
}
